import React, { useState } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar';

function ChatWithGpt() {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: 'user', text: input }];
    setMessages(newMessages);
    setInput('');
    setLoading(true);

    const backendUrl = `https://gemini-backend-fcdb.onrender.com`;

    try {
      const res = await axios.post(`${backendUrl}/api/ai/chat`, {
        prompt: input
      });

      const reply = res.data?.candidates?.[0]?.content?.parts?.[0]?.text;
      setMessages([...newMessages, { role: 'ai', text: reply || 'No response' }]);
    } catch (err) {
      console.error('Error from AI backend:', err);
      setMessages([...newMessages, { role: 'ai', text: 'Error getting response.' }]);
    }

    setLoading(false);
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Sidebar for desktop */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Sidebar for mobile (optional toggle can be added later)
      <div className="md:hidden">
        <Sidebar />
      </div> */}

      <div className="w-full max-w-full md:max-w-2xl mx-auto p-4 flex-1">
        <h1 className="text-2xl bg-gradient-to-r from-violet-500 to-red-500 text-transparent bg-clip-text font-bold mb-4 text-center">
          Unito AI
        </h1>

        {/* Chat window */}
        <div className="bg-gradient-to-r from-violet-400 to-red-400 rounded-lg p-4 h-[400px] overflow-y-auto space-y-4">
          {messages.map((msg, idx) => (
            <div
              key={idx}
              className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`rounded-xl px-4 py-2 max-w-[80%] sm:max-w-[75%] whitespace-pre-wrap ${
                  msg.role === 'user'
                    ? 'bg-blue-500 text-white'
                    : 'bg-white text-gray-800 border'
                }`}
              >
                <strong>{msg.role === 'user' ? 'You' : 'Unito AI'}</strong>
                <div>{msg.text}</div>
              </div>
            </div>
          ))}
          {loading && (
            <div className="flex justify-start">
              <div className="bg-white border text-gray-800 rounded-xl px-4 py-2 max-w-[80%] sm:max-w-[75%]">
                <strong>Unito AI</strong>
                <div>Typing...</div>
              </div>
            </div>
          )}
        </div>

        {/* Input area */}
        <div className="mt-4 flex flex-col sm:flex-row items-stretch sm:items-center space-y-2 sm:space-y-0 sm:space-x-2">
          <input
            type="text"
            placeholder="Ask something about DSA..."
            className="flex-1 border rounded px-3 py-2"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
          />
          <button
            onClick={handleSend}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatWithGpt;
